<template>
  <div id="main">
    <!-- popup component -->
    <PopupModal />
    <!-- header component -->
    <Header :showInfo="false" />
    <ul class="project-list">
      <!-- for loop of list.vue -->
      <router-link
        :to="{ name: 'detail', params: { prjIdx: idx } }"
        tag="li"
        v-for="(item, idx) in projectList"
        :class="[item.portrait ? 'portrait' : '', `grid${idx}`]"
        v-bind:id="'project' + idx"
        :key="item.idx"
      >
        <div class="list-photo">
          <div>
            <img :src="getImgUrl(item.name)" />
            <p>{{ item.name }}</p>
          </div>
        </div>
      </router-link>
    </ul>
    <p class="copyright">
      copyright &copy; LeeJaeHa Architects. all rights reserved.
    </p>
  </div>
</template>

<script>
import PopupModal from "./Popup.vue";
import EventBus from "../eventBus.js";

export default {
  components: {
    PopupModal,
  },
  created() {
    EventBus.$on("use-eventbus", () => {
      this.$modal.show("popup-modal");
    });
  },
  methods: {
    getImgUrl: function(pet) {
      return require("../assets/project/" + pet + "/thumb.jpg");
    },
  },
};
</script>

<style>
.example-modal-content {
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  font-size: 13px;
  overflow: auto;
}
</style>
